import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './SchoolInfoItem.scss';

const SchoolInfoItem = ({ icon, children }) => (
  <div className={style.root}>
    {icon}
    <div className={style.meta}>{children}</div>
  </div>
);

SchoolInfoItem.propTypes = {
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(style)(SchoolInfoItem);
